export const STORES_RESET_STATE = 'STORES_RESET_STATE';
export const STORES_CURRENT_ITEM = 'STORES_CURRENT_ITEM';

export const STORES_REQUEST_LOADING = 'STORES_REQUEST_LOADING';
export const STORES_REQUEST_SUCCESS = 'STORES_REQUEST_SUCCESS';
export const STORES_REQUEST_FAILED = 'STORES_REQUEST_FAILED';

export const STORES_CURRENT_ACTION = 'STORES_CURRENT_ACTION';
export const STORES_RESET_ACTION = 'STORES_RESET_ACTION';